import { render } from "./diklat-print-page-break.vue?vue&type=template&id=282313ec&scoped=true"
import script from "./diklat-print-page-break.vue?vue&type=script&lang=js"
export * from "./diklat-print-page-break.vue?vue&type=script&lang=js"

import "./diklat-print-page-break.vue?vue&type=style&index=0&id=282313ec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282313ec"]])

export default __exports__